module.exports = __webpack_public_path__ + "static/media/sim-link-bg.1f0a291f.jpg";